/* global $, fantastiquebazar */
import LocomotiveScroll from 'locomotive-scroll';
import LoadMore from './LoadMore';
import 'owl.carousel';

$(document).ready(() => {
	// EDGE
	if (-1 !== navigator.appVersion.indexOf('Edge')) {
		$('html').addClass('edge');
	}

	// init smooth scroll for parallax + animations

	const scroll = new LocomotiveScroll({
		el: document.querySelector('#main'),
		smooth: true,
		lerp: 0.12,
		repeat: true,
	});

	// listen to scroll event
	scroll.on('scroll', obj => {
		const { y } = obj.scroll;

		if (80 < y) {
			$('.header').addClass('scroll');
		} else {
			$('.header').removeClass('scroll');
		}
	});

	// update scroll
	setTimeout(() => {
		scroll.update();
	}, 1000);

	[...document.querySelectorAll('.js-load-more')].forEach($loadMore => {
		const loadMore = new LoadMore($loadMore);

		loadMore.init();

		$loadMore.addEventListener('unlocked', () => {
			// console.log('LoadMore.unlocked');

			if (JSON.parse($loadMore.getAttribute('data-loop'))) {
				scroll.scrollTo($loadMore);
			}

			scroll.update();
		});

		return true;
	});

	// accordion
	if ($('.accordion-js').length) {
		$('.accordion-js .wrapper > div').on('click', event => {
			const { currentTarget } = event;

			$('.accordion-js .wrapper > div').removeClass('active');
			$(currentTarget).addClass('active');
		});
	}

	// carousel assos
	if ($('.js-assos-carousel').length) {
		const slider = $('.js-assos-carousel');

		slider.owlCarousel({
			loop: 3 < $('.owl-carousel .js-assos-carousel-item').length,
			rewind: true,
			dots: false,
			nav: false,
			margin: 20,
			autoplay: true,
			autoplayTimeout: 3000,
			autoplayHoverPause: true,
			autoplaySpeed: 1000,
			responsive: {
				0: {
					items: 1,
					stagePadding: 100,
				},
				992: {
					items: 4,
					stagePadding: 150,
				},
			},
			onInitialized: () => scroll.update(),
		});
	}

	// carousel events
	if ($('.js-next-event-carousel').length) {
		const slider = $('.js-next-event-carousel');

		slider.owlCarousel({
			stagePadding: 250,
			loop: 1 < $('.owl-carousel .js-next-event-carousel-item').length,
			items: 1,
			autoWidth: true,
			dots: false,
			nav: true,
			responsive: {
				0: {
					center: false,
					margin: 20,
				},
				992: {
					center: true,
					margin: 60,
				},
			},
			onInitialized: () => {
				scroll.update();
			},
		});
	}

	// load iframe and update scroll
	function callIframe() {
		$('.vocal__embed__iframe').append(
			'<iframe id="fantastique-vocal" src="" allow="camera; microphone; autoplay; encrypted-media;" width="100%" height="600px"></iframe>',
		);
		$('#fantastique-vocal').attr('src', fantastiquebazar.iframe_src);
		$('#fantastique-vocal').on('load', () => scroll.update());
	}

	if ($('.vocal__embed').length && fantastiquebazar.iframe_src) {
		callIframe();
	}

	// slider home mobile
	let $sliderMissions = null;

	function initSliderMissions() {
		if ($('.home .grid-boxes').length || $('.page-template-diagnosis .grid-boxes').length) {
			if (991 >= window.innerWidth) {
				$sliderMissions = $('.grid-boxes .grid');
				$sliderMissions.addClass('owl-carousel');

				$sliderMissions.owlCarousel({
					items: 1,
					autoWidth: true,
					dots: false,
					nav: false,
					margin: 20,
					center: true,
					onInitialized: () => scroll.update(),
				});
			} else if ($sliderMissions) {
				$sliderMissions.owlCarousel();
				$sliderMissions.trigger('destroy.owl.carousel');
			}
		}
	}

	initSliderMissions();

	$(window).on('resize', () => {
		initSliderMissions();
	});

	// nav mobile
	$('#toggle-menu').on('click', event => {
		const { currentTarget } = event;

		$(currentTarget).toggleClass('animate');
		$('.header__nav').toggleClass('animate');
	});
});
